import { render, staticRenderFns } from "./CountInfo.vue?vue&type=template&id=0001510c&scoped=true&"
import script from "./CountInfo.vue?vue&type=script&lang=js&"
export * from "./CountInfo.vue?vue&type=script&lang=js&"
import style0 from "./CountInfo.vue?vue&type=style&index=0&id=0001510c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0001510c",
  null
  
)

export default component.exports